import React from 'react';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(18, 60, 46, 0.4)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 9998
                }}
                onClick={onClose}
            />
            <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'white',
                    borderRadius: '1rem',
                    padding: '2rem',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    zIndex: 9999,
                    maxWidth: '400px',
                    width: '90%'
                }}
            >
                <h3 style={{
                    margin: '0 0 1rem 0',
                    fontSize: '1.5rem',
                    fontFamily: 'serif',
                    color: '#123c2e'
                }}>
                    {title}
                </h3>
                <p style={{
                    margin: '0 0 2rem 0',
                    color: '#3e7140',
                    lineHeight: '1.5'
                }}>
                    {message}
                </p>
                <div style={{
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'flex-end'
                }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '0.75rem 1.5rem',
                            background: '#f4f0e6',
                            color: '#123c2e',
                            border: 'none',
                            borderRadius: '0.5rem',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.background = '#e5e0d0'}
                        onMouseOut={(e) => e.target.style.background = '#f4f0e6'}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        style={{
                            padding: '0.75rem 1.5rem',
                            background: '#dc2626',
                            color: 'white',
                            border: 'none',
                            borderRadius: '0.5rem',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.background = '#b91c1c'}
                        onMouseOut={(e) => e.target.style.background = '#dc2626'}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </>
    );
};

export default ConfirmModal;
